export function showHeader() {
  const header = document.querySelector('.header'),
    btnArr = document.querySelectorAll('main .btn--play');

  btnArr.forEach(btn => {
    if (btn.getBoundingClientRect().y < window.innerHeight && btn.getBoundingClientRect().bottom < window.innerHeight) {
      if (btn.getBoundingClientRect().bottom < 0) {
        header.classList.remove('hide');
      } else {
        header.classList.add('hide');
      }
    }
  })
}